import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  showIcon?: boolean;
  scrollToSection?: boolean;
  checkoutUrl?: string;
}
export function CTAButton({
  text = 'QUIERO ACCESO INMEDIATO',
  className = '',
  fullWidth = false,
  size = 'lg',
  showIcon = true,
  scrollToSection = false,
  checkoutUrl = 'https://pay.hotmart.com/P104026694B?checkoutMode=10'
}: CTAButtonProps) {
  const baseClasses = 'font-bold rounded-full shadow-[0_4px_0_rgb(154,52,18)] active:shadow-none active:translate-y-[4px] transition-all duration-150 flex items-center justify-center gap-2 uppercase tracking-wide';
  const sizeClasses = {
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg md:text-xl',
    xl: 'py-5 px-10 text-xl md:text-2xl'
  };
  const colorClasses = 'bg-orange-500 hover:bg-orange-400 text-white border-2 border-orange-600';
  const handleClick = (e: React.MouseEvent) => {
    if (scrollToSection) {
      e.preventDefault();
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  if (scrollToSection) {
    return <motion.button onClick={handleClick} className={`${baseClasses} ${sizeClasses[size]} ${colorClasses} ${fullWidth ? 'w-full' : 'w-auto'} ${className} cursor-pointer`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-257">
        {text}
        {showIcon && <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-258" />}
      </motion.button>;
  }
  return <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className={`${baseClasses} ${sizeClasses[size]} ${colorClasses} ${fullWidth ? 'w-full' : 'w-auto'} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-259">
      {text}
      {showIcon && <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-260" />}
    </motion.a>;
}